export const NfseRoles = {
  NFSE: "nfse",
  NFSE_ADMIN: "nfse_admin",
  NFSE_AUDITORIA: "nfse_auditoria",
} as const;

export type NfseRole = (typeof NfseRoles)[keyof typeof NfseRoles];

/** Qualquer acesso ao módulo NFS-e. */
export const NFSE_MODULE_ROLES: NfseRole[] = [
  NfseRoles.NFSE,
  NfseRoles.NFSE_ADMIN,
  NfseRoles.NFSE_AUDITORIA,
];

/** Operação (consulta, reemissão, cancelamento, config fiscal). */
export const NFSE_OPERACAO_ROLES: NfseRole[] = [
  NfseRoles.NFSE,
  NfseRoles.NFSE_ADMIN,
];

/** Somente auditoria / visão somente leitura no detalhe. */
export const NFSE_AUDITORIA_ROLES: NfseRole[] = [NfseRoles.NFSE_AUDITORIA];
